Object.defineProperty(exports, "__esModule", {
  value: true
});

var _animated = require('animated');

var _animated2 = _interopRequireDefault(_animated);

var _ScrollContainer = require('./ScrollContainer');

var _ScrollContainer2 = _interopRequireDefault(_ScrollContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// the difference between this component and the pure `ScrollContainer` is that
// this component can understand an Animated.Value as a prop type, e.g. for `scrollLeft`
exports['default'] = _animated2['default'].createAnimatedComponent(_ScrollContainer2['default']);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/private/AnimatedScrollContainer.js
// module id = 150
// module chunks = 923280921217 19843951674672